import React, { useRef } from 'react'
import { useGetASLGeneralReportQuery as query } from 'features'
import { DataGrid } from 'vendor/x-data-grid'
import { ErrorBoundary } from 'components'
import { useDataGridDefaults } from 'hooks'
import { generalASLReportColumns as columnDefinition } from 'pages/reports'
import ASLGeneralReportGridFrooter from 'pages/reports/ASLGeneralReportGridFrooter'
import { ReportExport } from 'pages/reports/ReportExport'

export default function ViewASLOverviewReport(_props) {
  const { data, isLoading, error } = query()

  const [dataGridProps] = useDataGridDefaults()

  const topOffGridRef = useRef(null)

  const getRowId = useRef((row) => row['cycle'])

  return (
    <div className="py-12" ref={topOffGridRef}>
      <ErrorBoundary fallback={<div>Error</div>}>
        {data && !isLoading && !error && (
          <>
            <div className="flex justify-end items-center mb-4">
              <ReportExport
                query={query}
                columns={columnDefinition}
                title="Reporte ASL General"
                fileName="Reporte ASL General"
              />
            </div>
            <div
              style={{
                width: '100%',
                height:
                  /* (topOffGridRef.current?.offsetTop || 0) + */ 40 +
                  data?.rows?.length * 59 +
                  'px',
              }}
            >
              <DataGrid
                {...dataGridProps}
                getRowId={getRowId.current}
                columns={columnDefinition}
                autoHeight={true}
                loading={isLoading}
                rows={data?.rows}
                rowCount={data?.rows?.length}
                components={{ Footer: ASLGeneralReportGridFrooter }}
                checkboxSelection={false}
                componentsProps={{
                  footer: { ...data?.total },
                }}
              />
            </div>
          </>
        )}
      </ErrorBoundary>
    </div>
  )
}
